import { ArrowBackOutlined, CloseOutlined } from '@mui/icons-material'
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    Icon,
    Typography,
} from '@mui/material'
import React from 'react'

interface SimplePopupProps {
    isOpen: boolean
    onClickBack: any
    title: string
    children: any
}

const SimplePopup: React.FC<SimplePopupProps> = ({ children, ...props }) => {
    const { isOpen, onClickBack, title } = props

    return (
        <Dialog
            open={isOpen}
            scroll="paper"
            PaperProps={{
                sx: {
                    width: '100%',
                    maxWidth: '920px!important',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            sx={{ padding: '10px 30px' }}
            onClose={() => onClickBack()}
        >
            <Box>
                <DialogTitle id="scroll-dialog-title" sx={{ padding: '0px' }}>
                    <Box display="flex" alignItems="center" padding="15px">
                        <Icon
                            onClick={() => onClickBack()}
                            sx={{ marginRight: '10px' }}
                            fontSize="small"
                        >
                            <ArrowBackOutlined
                                sx={{
                                    color: '#000',
                                    marginTop: '-2px',
                                }}
                            />
                        </Icon>
                        <Typography
                            sx={{
                                color: '#000',
                                fontSize: '18px',
                                fontWeight: 600,
                            }}
                        >
                            {title}
                        </Typography>
                        <Icon
                            onClick={() => onClickBack()}
                            sx={{ marginLeft: 'auto' }}
                            fontSize="small"
                        >
                            <CloseOutlined
                                sx={{
                                    color: '#000',
                                    marginTop: '-2px',
                                }}
                            />
                        </Icon>
                    </Box>
                </DialogTitle>
                <DialogContent
                    sx={{
                        height: 'calc(100vh - 250px)',
                    }}
                >
                    <Box sx={{ height: '100%' }}>{children}</Box>
                </DialogContent>
            </Box>
        </Dialog>
    )
}

export default SimplePopup
